import { render, staticRenderFns } from "./CalendarEvents.vue?vue&type=template&id=2f0d5008&"
import script from "./CalendarEvents.vue?vue&type=script&lang=ts&"
export * from "./CalendarEvents.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports